import styles from "../css/Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <img 
          src="/images/catieLogo.png" 
          alt="Logo CATIE" 
          className={styles.image}
        />
        <p className={styles.text}>
          La presente aplicación web ha sido desarrollada con el apoyo financiero de la Unión Europea a través del Proyecto Plataforma de información Nacional sobre Nutrición (PiNN) ejecutado por el CATIE (Centro Agronómico Tropical de Investigación y Enseñanza). El contenido de la presente aplicación es responsabilidad exclusiva de la Secretaría de Seguridad Alimentaria y Nutricional (SESAN) en ningún caso debe considerarse que refleja los puntos de vista de la Unión Europea. 
        </p>
      </div>
    </footer>
  );
}

export default Footer;
